import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import swal from "sweetalert";
import Swal from "sweetalert2";
const AppPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();


const [amount, setAmount] = useState(null);
const [email, setEmail] = useState(null);
  const [isFunctionCall, setIsFunctionCall] = useState(false);

  // Function to parse query parameters
  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    return {
      decodeAmount: atob(searchParams.get("amount")), // Decoding the amount
      decodeEmail: atob(searchParams.get("email")), // Decoding the email
    };
  };

  useEffect(()=>{
     const { decodeAmount, decodeEmail } = getQueryParams();
     setAmount(decodeAmount)
     setEmail(decodeEmail)

  },[location.search,location])
  console.log(email,amount,'query')
  // const { amount, email } = getQueryParams();

  // useEffect(() => {
  //   if (amount && email && window?.LencoPay) {
  //     setTimeout(() => {
  //       paymentHandler();
  //     }, 500);
  //   }
  // }, [amount, email,window?.LencoPay]);
  useEffect(() => {
    const checkAndCallPayment = () => {
      if (amount && email && window?.LencoPay) {
        paymentHandler();
      } else {
        console.log("Waiting for LencoPay to load...");
      }
    };

    // Retry every 500ms indefinitely until LencoPay is available
    const interval = setInterval(() => {
      if (window?.LencoPay) {
        clearInterval(interval);
        checkAndCallPayment();
      }
    }, 500);

    return () => clearInterval(interval);
  }, [amount, email,window?.LencoPay?.getPaid]);

  const paymentHandler = async () => {
    setIsFunctionCall(true);
    window?.LencoPay?.getPaid({
      key: process.env.REACT_APP_LENCO_PUBLIC_KEY, // Replace with your actual Lenco public key
      reference: "ref-" + Date.now(), // Generate a unique reference
      email: email, // Customer's email address
      amount: parseInt(amount).toFixed(2), // Amount to be paid (in ZMW)
      currency: "ZMW", // Currency for the transaction
      channels: ["card", "mobile-money"], // Payment channels
      customer: {
        firstName: "", // Customer's first name
        lastName: "", // Customer's last name
        phone: "", // Customer's phone number
      },
      onSuccess: (response) => {
        // Callback when payment is completed successfully
        const reference = response.reference;
        // alert("Payment complete! Reference: " + reference);
        // navigate(`/app-payment/success`, {
        //   state: { response },
        // });

        navigate(`/pay/success`, {
          state: { response },
        });
        // Here you can make an AJAX call to your server to verify the payment
      },
      onClose: () => {
        // alert("Payment was not completed, window closed.");
        // navigate(`/app-payment/failed`);
        Swal.fire({
          title: "Payment Failed",
          text: "Unfortunately, your payment could not be processed.",
          icon: "error",
          confirmButtonText: "OK",
        }).then((result) => {
          // Navigate on confirm or dismiss
          if (result.isConfirmed || result.isDismissed) {
            navigate("/app-payment/failed");
          }
        });
      },
      onConfirmationPending: () => {
        // alert("Your purchase will be completed when the payment is confirmed.");
        // swal({
        //   title: "Booking Pending",
        //   text: "Your Booking will be completed when the payment is confirmed.",
        //   icon: "info",
        //   button: "OK",
        // });
        // navigate(`/app-payment/pending`);

        Swal.fire({
          title: "Booking Pending",
          text: "Your Booking will be completed when the payment is confirmed.",
          icon: "info",
          confirmButtonText: "OK",
        }).then(() => {
          // Navigate when OK or dismiss is clicked
          navigate("/app-payment/pending");
        });
      },
    });
  };
  return (
    <>  
      {!isFunctionCall && (
        // <div className="loader-overlay">
        //   <div className="loader-container">
        //     <p>Please wait...</p>
        //     <div className="loader-dots-circle">
        //       <span></span>
        //       <span></span>
        //       <span></span>
        //       <span></span>
        //       <span></span>
        //     </div>
        //   </div>
        // </div>
          <div className="loader-overlay">
          <div className="loader-container">
       
        <div className="ml-loader ms-3">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p>Please wait...</p>
      </div>
      </div>
      )}
    </>
  );
};

export default AppPayment;
